
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/[username]/likes",
      function () {
        return require("private-next-pages/user/[username]/likes.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/[username]/likes"])
      });
    }
  